module.exports = __webpack_public_path__ + "static/img/11.8da7e9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/11.png
// module id = lLBG
// module chunks = 0